"use strict";

/**
 * An array of numbers representing an extent: `[minx, miny, maxx, maxy]`.
 *
 * @typedef {Array<number>} gc.gis.GCExtent
 */

/**
 *	Statische Klasse für die Verarbeitung von Extents.
 *
 *	@class
 *	@static
 *	@author	Christian Schmidt <c.schmidt@brain-scc.de>
 */
gc.gis.GCExtent = {

	/**
	 *
	 * @method
	 * @return {gc.gis.GCExtent} Extent
	 * @public
	 */
	createEmpty: function()
	{
		return [Infinity, Infinity, -Infinity, -Infinity];
	},

	/**
	 *
	 * @method
	 * @param {gc.gis.GCExtent} extent
	 * @return {boolean}
	 * @public
	 */
	isEmpty: function(extent)
	{
		return extent[2] < extent[0] || extent[3] < extent[1];
	},

	/**
	 * Liefert die Fläche des Extent.
	 *
	 * @method
	 * @param {gc.gis.GCExtent} extent Extent
	 * @return {number} Fläche
	 * @public
	 */
	getArea: function(extent)
	{
		var area = 0;
		if (!isEmpty(extent))
		{
			area = this.getWidth(extent) * this.getHeight(extent);
		}

		return area;
	},

	/**
	 * Liefert die Breite des Extent.
	 *
	 * @method
	 * @param {gc.gis.GCExtent} extent Extent
	 * @return {number} Breite
	 * @public
	 */
	getWidth: function(extent)
	{
		return extent[2] - extent[0];
	},

	/**
	 * Liefert die Höhe des Extent.
	 *
	 * @method
	 * @param {gc.gis.GCExtent} extent Extent
	 * @return {number} Höhe
	 * @public
	 */
	getHeight: function(extent)
	{
		return extent[3] - extent[1];
	},

	/**
	 * Liefert die Mittelpunkt-Koordinate des Extent.
	 *
	 * @method
	 * @param {gc.gis.GCExtent} extent Extent
	 * @return {Array<number>} Mittelpunkt
	 * @public
	 */
	getCenter: function(extent)
	{
		return [(extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2];
	}
};